import { EmptyAction, InitAction, LoadedAction, BootstrapTypes } from '../actions'

type BootstrapAction = InitAction | LoadedAction | EmptyAction

export interface State {
  readonly bootstrapping: boolean,
  readonly loaded: boolean,
}

export const INITIAL_STATE: State = {
  bootstrapping: false,
  loaded: false,
}

export default (state: State = INITIAL_STATE, action: BootstrapAction): State => {
  switch (action.type) {
    case BootstrapTypes.INIT:
      return { ...state, bootstrapping: true }
    case BootstrapTypes.LOADED:
      return { ...state, bootstrapping: false, loaded: true }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/app.ts